export const BREADCRUMBS_IDS = {
  connect: "connect",
  isxPayoutConfiguration: "isx-payout-configuration",
  accounts: "accounts",
  accountDetails: "connect-account-details",
  accountCreate: "connect-account-create",
  providerConfigList: "connect-provider-config-list",
  reportNotificationsSettings: "connect-notifications",
  providerConfigDetails: "connect-provider-config-details",
} as const;
